/** What the Commerce Agent dashboard can split reach and conversations by. */
export enum CommerceAgentEngagementGroup {
  /** The trigger of the outreach an event falls under. */
  TRIGGER = "trigger",
  /** Whether the agent's sends skipped the human review queue, as the
   *  Performance report's audience reads it. */
  SUBSCRIBER_STATUS = "subscriber_status",
}
